__webpack_require__.p = "/TechWorld-TypeScript/";